// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3519bbaa","485":"0ae78573"}[chunkId] + ".chunk.js";
};